export const _3g2MimeTypes = ["video/3g2"];
